export function colorMix(
    color = "",
    mix = 100,
    secondaryColor = "transparent",
) {
    return `color-mix(in srgb, ${color} ${mix}%, ${secondaryColor})`;
}

export function getColor(color = "") {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(`--${color}`)
        .trim();
}
